import {Presenter} from '../../../Support/with_presenter';
import {Duration} from '../../../Domain/Duration';
import {Distance} from '../../../Domain/Distance';
import {Speed} from '../../../Domain/Speed';
import {PartialWorkout} from '../../../Models/PartialWorkout';
import {loadingResponse, NetworkResult} from '../../../Network/NetworkResult';
import {DownloadedIndoorWorkout} from '../../../Models/DownloadedIndoorWorkout';
import {StrokesService} from '../../../Network/StrokesService';
import {workoutTitleFormatter} from '../../Support/workoutTitleFormatter';
import {WorkoutExecutionType} from '../../../Models/WorkoutExecutionType';
import {GeoTrack} from '../../../Models/GeoTrack';
import {TracksDownloadService} from '../../../Network/TracksDownloadService';
import { calculateConclusions } from '../../Report/Show/Trend/Widgets/Internal/conclusionsCalculator';
import { calculateIndoorWorkoutListSummary } from '../../../Strokes/calculateIndoorWorkoutListSummary';

export class WorkoutCardPresenter implements Presenter {
    public indoorDownloadResult: NetworkResult<DownloadedIndoorWorkout> = loadingResponse();
    public geoTrackDownloadResult: NetworkResult<GeoTrack> = loadingResponse();

    constructor(
        private workoutCardViewModel: WorkoutCardViewModel,
        private strokesService: StrokesService,
        private tracksDownloadService: TracksDownloadService,
    ) {}

    public async mount(): Promise<void> {
        if (this.workoutCardViewModel.executionType === WorkoutExecutionType.INDOOR) {
            this.indoorDownloadResult = await this.strokesService.forWorkoutId(this.workoutCardViewModel.id);
        }
        if (this.workoutCardViewModel.executionType === WorkoutExecutionType.OUTDOOR) {
            this.geoTrackDownloadResult = await this.tracksDownloadService.forGeoTrackUrl(
                this.workoutCardViewModel.trackGeoUrl,
            );
        }
    }

    public unmount(): void {
        /* Noop */
    }
}

export class WorkoutCardViewModel {
    constructor(
        public id: number,
        public executionType: WorkoutExecutionType,
        public title: string | null,
        public executedAt: Date,
        public duration: Duration,
        public distance: Distance,
        public speed: Speed,
        public trackGeoUrl: string | null,
    ) {}

    public static fromPartialWorkout(partialWorkout: PartialWorkout): WorkoutCardViewModel {

        const indoorWorkoutListSummary = calculateIndoorWorkoutListSummary(partialWorkout);


        return new WorkoutCardViewModel(
            partialWorkout.id,
            partialWorkout.execution_type,
            workoutTitleFormatter(partialWorkout),
            partialWorkout.executed_at,
            indoorWorkoutListSummary.duration,
            indoorWorkoutListSummary.distance,
            Speed.fromDistanceAndDuration(indoorWorkoutListSummary.distance, indoorWorkoutListSummary.duration),
            partialWorkout.track_geo_url,
        );
    }
}
